import { render, staticRenderFns } from "./travel-insurance-upsell-card.vue?vue&type=template&id=3c22e194&scoped=true"
import script from "./travel-insurance-upsell-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./travel-insurance-upsell-card.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./travel-insurance-upsell-card.vue?vue&type=style&index=0&id=3c22e194&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c22e194",
  null
  
)

export default component.exports